/**
 * Do not edit directly
 * Generated on Tue, 05 Aug 2025 14:28:15 GMT
 */

export const PaddingSpacingNone = 0;
export const PaddingSpacing3Xs = 8;
export const PaddingSpacing2Xs = 16;
export const PaddingSpacingXs = 24;
export const PaddingSpacingS = 32;
export const PaddingSpacingSm = 40;
export const PaddingSpacingM = 48;
export const PaddingSpacingMl = 56;
export const PaddingSpacingL = 64;
export const PaddingSpacingXl = 80;
export const PaddingSpacing2Xl = 96;
export const PaddingSpacing3Xl = 160;
export const PaddingSpacing4Xl = 240;
export const SizingXs = 4;
export const SizingS = 8;
export const SizingM = 12;
export const SizingL = 16;
export const SizingXl = 24;
export const SizingXxl = 40;
export const SizingXxxl = 64;
export const RadiusXs = 8;
export const RadiusS = 8;
export const RadiusM = 12;
export const RadiusL = 16;
export const RadiusXl = 32;
export const RadiusXxl = 40;
export const RadiusXxxl = 64;
export const FontFamiliesPrimary = "Instrument Sans";
export const FontFamiliesSecondary = "Space Grotesk";
export const LineHeights100 = 16;
export const LineHeights200 = 18;
export const LineHeights300 = 20;
export const LineHeights400 = 24;
export const LineHeights500 = 28;
export const LineHeights600 = 32;
export const LineHeights700 = 36;
export const LineHeights800 = 40;
export const LineHeights900 = 48;
export const LineHeights1000 = 64;
export const LineHeights1100 = 84;
export const FontWeights400 = "Regular";
export const FontWeights500 = "Medium";
export const FontWeights700 = "Bold";
export const FontWeightsItalic = "Italic";
export const FontSize100 = 13;
export const FontSize200 = 16;
export const FontSize300 = 18;
export const FontSize400 = 20;
export const FontSize500 = 24;
export const FontSize600 = 30;
export const FontSize700 = 36;
export const FontSize800 = 48;
export const FontSize900 = 64;
export const LetterSpacing0 = "0%";
export const LetterSpacing1 = "3%";
export const LetterSpacing2 = "10%";
export const ParagraphSpacing0 = 0;
export const ParagraphSpacing1 = 10;
export const DesktopH1FontFamily = "Instrument Sans";
export const DesktopH1FontWeight = "Bold";
export const DesktopH1LineHeight = 84;
export const DesktopH1FontSize = 64;
export const DesktopH1TextDecoration = "none";
export const DesktopH2FontFamily = "Instrument Sans";
export const DesktopH2FontWeight = "Bold";
export const DesktopH2LineHeight = 64;
export const DesktopH2FontSize = 48;
export const DesktopH2TextDecoration = "none";
export const DesktopH3FontFamily = "Instrument Sans";
export const DesktopH3FontWeight = "Bold";
export const DesktopH3LineHeight = 48;
export const DesktopH3FontSize = 36;
export const DesktopH3TextDecoration = "none";
export const DesktopH4FontFamily = "Instrument Sans";
export const DesktopH4FontWeight = "Bold";
export const DesktopH4LineHeight = 36;
export const DesktopH4FontSize = 24;
export const DesktopH4TextDecoration = "none";
export const DesktopH5FontFamily = "Instrument Sans";
export const DesktopH5FontWeight = "Bold";
export const DesktopH5LineHeight = 32;
export const DesktopH5FontSize = 20;
export const DesktopH5TextDecoration = "none";
export const DesktopH6FontFamily = "Space Grotesk";
export const DesktopH6FontWeight = "Medium";
export const DesktopH6LineHeight = 36;
export const DesktopH6FontSize = 24;
export const DesktopH6TextDecoration = "none";
export const DesktopSubtitleFontFamily = "Space Grotesk";
export const DesktopSubtitleFontWeight = "Regular";
export const DesktopSubtitleLineHeight = 32;
export const DesktopSubtitleFontSize = 20;
export const DesktopSubtitleTextDecoration = "none";
export const DesktopButtonFontFamily = "Space Grotesk";
export const DesktopButtonFontWeight = "Bold";
export const DesktopButtonLineHeight = 24;
export const DesktopButtonFontSize = 18;
export const DesktopButtonTextDecoration = "none";
export const DesktopButtonLetterSpacing = "3%";
export const DesktopButtonSmallFontFamily = "Space Grotesk";
export const DesktopButtonSmallFontWeight = "Regular";
export const DesktopButtonSmallLineHeight = 24;
export const DesktopButtonSmallFontSize = 13;
export const DesktopButtonSmallTextDecoration = "none";
export const DesktopButtonSmallLetterSpacing = "3%";
export const DesktopBodyFontFamily = "Instrument Sans";
export const DesktopBodyFontWeight = "Regular";
export const DesktopBodyLineHeight = 32;
export const DesktopBodyFontSize = 18;
export const DesktopBodyTextDecoration = "none";
export const DesktopBodyParagraphSpacing = 10;
export const DesktopBodyStrongFontFamily = "Instrument Sans";
export const DesktopBodyStrongFontWeight = "Bold";
export const DesktopBodyStrongLineHeight = 32;
export const DesktopBodyStrongFontSize = 18;
export const DesktopBodyStrongTextDecoration = "none";
export const DesktopBodyStrongParagraphSpacing = 10;
export const DesktopBodyItalicFontFamily = "Instrument Sans";
export const DesktopBodyItalicFontWeight = "Italic";
export const DesktopBodyItalicLineHeight = 32;
export const DesktopBodyItalicFontSize = 18;
export const DesktopBodyItalicTextDecoration = "none";
export const DesktopBodyItalicParagraphSpacing = 10;
export const DesktopBodyLinkFontFamily = "Instrument Sans";
export const DesktopBodyLinkFontWeight = "Regular";
export const DesktopBodyLinkLineHeight = 32;
export const DesktopBodyLinkFontSize = 18;
export const DesktopBodyLinkTextDecoration = "underline";
export const DesktopBodyLinkParagraphSpacing = 10;
export const DesktopBodySmallFontFamily = "Instrument Sans";
export const DesktopBodySmallFontWeight = "Regular";
export const DesktopBodySmallLineHeight = 20;
export const DesktopBodySmallFontSize = 13;
export const DesktopBodySmallTextDecoration = "none";
export const DesktopBodySmallStrongFontFamily = "Instrument Sans";
export const DesktopBodySmallStrongFontWeight = "Bold";
export const DesktopBodySmallStrongLineHeight = 20;
export const DesktopBodySmallStrongFontSize = 13;
export const DesktopBodySmallStrongTextDecoration = "none";
export const DesktopBodySmallItalicFontFamily = "Instrument Sans";
export const DesktopBodySmallItalicFontWeight = "Italic";
export const DesktopBodySmallItalicLineHeight = 20;
export const DesktopBodySmallItalicFontSize = 13;
export const DesktopBodySmallItalicTextDecoration = "none";
export const DesktopBodySmallLinkFontFamily = "Instrument Sans";
export const DesktopBodySmallLinkFontWeight = "Regular";
export const DesktopBodySmallLinkLineHeight = 20;
export const DesktopBodySmallLinkFontSize = 13;
export const DesktopBodySmallLinkTextDecoration = "underline";
export const DesktopCategoryFontFamily = "Space Grotesk";
export const DesktopCategoryFontWeight = "Bold";
export const DesktopCategoryLineHeight = 20;
export const DesktopCategoryFontSize = 13;
export const DesktopCategoryTextDecoration = "none";
export const DesktopTagFontFamily = "Space Grotesk";
export const DesktopTagFontWeight = "Medium";
export const DesktopTagLineHeight = 20;
export const DesktopTagFontSize = 13;
export const DesktopTagTextDecoration = "none";
export const DesktopCaptionFontFamily = "Space Grotesk";
export const DesktopCaptionFontWeight = "Regular";
export const DesktopCaptionLineHeight = 20;
export const DesktopCaptionFontSize = 13;
export const DesktopCaptionTextDecoration = "none";
export const DesktopLabelFontFamily = "Instrument Sans";
export const DesktopLabelFontWeight = "Medium";
export const DesktopLabelLineHeight = 18;
export const DesktopLabelFontSize = 13;
export const DesktopLabelTextDecoration = "none";
export const DesktopPlaceholderFontFamily = "Space Grotesk";
export const DesktopPlaceholderFontWeight = "Medium";
export const DesktopPlaceholderLineHeight = 24;
export const DesktopPlaceholderFontSize = 16;
export const DesktopPlaceholderTextDecoration = "none";
export const TextDecorationNone = "none";
export const TextDecorationUnderline = "underline";
export const ComponentButtonPaddingLeft = 32;
export const ComponentButtonPaddingRight = 32;
export const ComponentButtonPaddingTop = 16;
export const ComponentButtonPaddingBottom = 16;
export const Numbers0 = 0;
export const Numbers2 = 2;
export const Numbers4 = 4;
export const Numbers8 = 8;
export const Numbers12 = 12;
export const Numbers14 = 14;
export const Numbers16 = 16;
export const Numbers20 = 20;
export const Numbers22 = 22;
export const Numbers24 = 24;
export const Numbers32 = 32;
export const Numbers40 = 40;
export const Numbers48 = 48;
export const Numbers56 = 56;
export const Numbers64 = 64;
export const Numbers80 = 80;
export const Numbers96 = 96;
export const Numbers128 = 128;
export const Numbers160 = 160;
export const Numbers248 = 240;
